import type { Stats } from '../types';

export const Results = ({ stats }: { stats: Stats }) => {
  const peak = Math.max(...stats.distribution.map((entry) => entry.count), 1);

  return (
    <section className={`results${stats.consensus ? ' results-consensus' : ''}`}>
      <div className="results-figures">
        {stats.average !== null && (
          <div className="figure">
            <span className="figure-value">{stats.average}</span>
            <span className="figure-label">Average</span>
          </div>
        )}
        <div className="figure">
          <span className="figure-value">{stats.median ?? '—'}</span>
          <span className="figure-label">Median</span>
        </div>
        <div className="figure">
          <span className="figure-value">
            {stats.low === stats.high ? stats.low : `${stats.low}–${stats.high}`}
          </span>
          <span className="figure-label">Range</span>
        </div>
        <div className="figure">
          <span className="figure-value">{stats.votes}</span>
          <span className="figure-label">Cards</span>
        </div>
      </div>

      <div className="distribution">
        {stats.distribution.map((entry) => (
          <div key={entry.cardId} className="bar">
            <div className="bar-track">
              <div className="bar-fill" style={{ height: `${(entry.count / peak) * 100}%` }} />
            </div>
            <span className="bar-label">{entry.label}</span>
            <span className="bar-count">{entry.count}</span>
          </div>
        ))}
      </div>

      {stats.consensus && <p className="consensus-note">🎉 Everyone agreed</p>}
    </section>
  );
};
